import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Branch } from '../../../shared/model/branch';
import { BranchService } from '../../../shared/service/branch.service';
import { FindHttpError } from '../../../shared/error/find-http-error';
import { UPDATE_BRANCH_FILTER } from '../../../core/actions';
import { ArgosState } from '../../../core/argos-state';
import { Observable } from 'rxjs/Observable';
import { NgRedux } from '@angular-redux/store';
import { PageInfo } from '../../../shared/model/page-info';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-branch-list',
  templateUrl: './branch-list.component.html',
  styleUrls: ['./branch-list.component.css']
})
export class BranchListComponent implements OnInit {
  branches: Array<Branch>;
  pageNumber = 0;
  pageSize = 15;
  pageInfo: PageInfo;
  nextDisabled = false;

  filterField = ['branchFilter'];
  nameFilter = ['name'];
  customerNameFilter = ['customerName'];
  cityFilter = ['city'];
  stateFilter = ['state'];
  osFilter = ['os'];
  jiraTicketFilter = ['jiraTicket'];
  invoiceNumberFilter = ['invoiceNumber'];
  filter = [];
  filterIsOpened = false;
  filterLabel = '';
  filterActionType = UPDATE_BRANCH_FILTER;
  inputTypeFilter = 'text';
  branchFilter$: Observable<any>;

  constructor(private _branchService: BranchService,
              private _router: Router,
              private _ngRedux: NgRedux<ArgosState>,
              private _toastService: ToastService) {
    this.branches = new Array<Branch>();
    this.findBranches();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  newBranch() {
    this._router.navigate([`branches`]);
  }

  editBranch(id: number) {
    this._router.navigate([`branches/${id}`]);
  }

  deleteBranch(id: number) { }

  findBranches() {
    this._branchService.findBranches(this.pageNumber, this.pageSize);
  }

  findByFilter() {
    this.pageNumber = 0;
    this.filterIsOpened = false;
    this.findBranches();
  }

  openFilter(inputType, label, filterField) {
    if (filterField[filterField.length - 1] === this.filter[this.filter.length - 1] && this.filterIsOpened) {
      this.filterIsOpened = false;
    } else {
      this.filter = this.filterField.concat(filterField);
      this.filterIsOpened = true;
      this.inputTypeFilter = inputType;
      this.filterLabel = label;
    }
  }

  goToPage(pageNumber) {
    this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    this.findBranches();
  }

  previousPage() {
    if (this.pageNumber > 0) {
      this.pageNumber = this.pageNumber - 1;
      this.findBranches();
    }
  }

  nextPage() {
    if (this.pageNumber < this.pageInfo.lastPage - 1) {
      this.pageNumber = this.pageNumber + 1;
      this.findBranches();
    }
  }

  private setUpObservers() {
    this.branchFilter$ = this._ngRedux.select('branchFilter');
    this.setUpFindAction(this._branchService.find$);
    this.setUpErrorAction(this._branchService.error$);
    this.setUpPageInfo(this._branchService.pageInfo$);
  }

  private setUpFindAction(observable) {
    observable
      .filter(branches => branches instanceof Array)
      .subscribe((branches: Array<Branch>) => {
          this.branches = branches;
      });
  }

  private setUpErrorAction(observable) {
    observable
      .filter(error => error instanceof FindHttpError)
      .subscribe((error) => {
        this.showMessage(error.text);
      });
  }

  private setUpPageInfo(observable) {
    observable
      .subscribe(pageInfo => this.pageInfo = pageInfo);
  }

  private showMessage(message: string) {
    this._toastService.showMessage(message, 4000);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/branch/component/branch-list/branch-list.component.ts